module.exports = __webpack_public_path__ + "img/image-collection-sliding-overlays-mazda.19b84679.png";